import { useState, useEffect } from 'react';
import { Table } from 'components/Elements';

export const TransactionHistory = ({ transactions }) => {
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    days: 7,
    currency: '',
    type: '',
    method: '',
    status: '',
  });
  const transactionsPerPage = 10;

  useEffect(() => {
    let filtered = transactions;

    if (filters.days) {
      const dateLimit = new Date();
      dateLimit.setDate(dateLimit.getDate() - filters.days);
      filtered = filtered.filter((tx) => new Date(tx.createdAt) >= dateLimit);
    }

    if (filters.currency) {
      filtered = filtered.filter((tx) => tx.currency === filters.currency);
    }

    if (filters.type) {
      filtered = filtered.filter((tx) => tx.transactionType === filters.type);
    }

    if (filters.method) {
      filtered = filtered.filter(
        (tx) => tx.transactionMethod === filters.method
      );
    }

    if (filters.status) {
      filtered = filtered.filter((tx) => tx.status === filters.status);
    }

    setFilteredTransactions(filtered);
    setCurrentPage(1);
  }, [filters, transactions]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const uniqueValues = (field) => [
    ...new Set(transactions.map((tx) => tx[field]).filter(Boolean)),
  ];

  const transactionColumns = [
    { title: 'Type', field: 'transactionType' },
    { title: 'Method', field: 'transactionMethod' },
    { title: 'Amount', field: 'amount' },
    { title: 'Currency', field: 'currency' },
    { title: 'Status', field: 'status' },
    {
      title: 'Date',
      field: 'createdAt',
      Cell: ({ entry }) => new Date(entry.createdAt).toLocaleString(),
    },
  ];

  const displayedTransactions = filteredTransactions.slice(
    (currentPage - 1) * transactionsPerPage,
    currentPage * transactionsPerPage
  );

  const totalPages = Math.ceil(
    (filteredTransactions.length > 0
      ? filteredTransactions.length
      : transactions.length) / transactionsPerPage
  );

  return (
    <div>
      <div className="text-white/50 mb-2 mx-4 font-semibold">Transaction History</div>
      <Table
        data={displayedTransactions}
        columns={transactionColumns}
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};
